var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.5 222",
    id: "svg65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "&#10;      .cls-1 {&#10;        fill: none;&#10;      }&#10;&#10;      .cls-2 {&#10;        fill: #6184ad;&#10;      }&#10;&#10;      .cls-3 {&#10;        clip-path: url(#clippath-1);&#10;      }&#10;&#10;      .cls-4 {&#10;        clip-path: url(#clippath-3);&#10;      }&#10;&#10;      .cls-5 {&#10;        clip-path: url(#clippath-2);&#10;      }&#10;&#10;      .cls-6 {&#10;        opacity: .5;&#10;      }&#10;&#10;      .cls-7 {&#10;        opacity: .1;&#10;      }&#10;&#10;      .cls-8 {&#10;        clip-path: url(#clippath);&#10;      }&#10;    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.2,
    y: 0,
    width: 227.7,
    height: 222,
    id: "rect1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.2,
    y: 0,
    width: 227.7,
    height: 222,
    id: "rect2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.5,
    y: -2,
    width: 234.3,
    height: 224.3,
    id: "rect3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.3,
    y: 4.7,
    width: 220.8,
    height: 212.6,
    id: "rect4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8",
    clipPath: "url(#clippath)",
    id: "g9",
    style: {
      display: "inline"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    clipPath: "url(#clippath-1)",
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    id: "g7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    clipPath: "url(#clippath-2)",
    id: "g6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.2,
    y: 0,
    width: 227.7,
    height: 222,
    id: "rect5"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 216.3,
    cy: 41.5,
    r: 0.8,
    id: "circle9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 197.2,
    cy: 87.7,
    r: 0.8,
    id: "circle10"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 178.4,
    cy: 124.2,
    r: 0.8,
    id: "circle11"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 148.8,
    cy: 108.8,
    r: 0.8,
    id: "circle12"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 155.8,
    cy: 55.1,
    r: 0.8,
    id: "circle13"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 169.1,
    cy: 16.6,
    r: 0.8,
    id: "circle14"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 131,
    cy: 6.7,
    r: 0.8,
    id: "circle15"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 108.8,
    cy: 35,
    r: 0.8,
    id: "circle16"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.1,
    cy: 15.3,
    r: 0.8,
    id: "circle17"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74.1,
    cy: 65.7,
    r: 0.8,
    id: "circle18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60,
    cy: 123.8,
    r: 0.8,
    id: "circle19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 89.3,
    cy: 163.8,
    r: 0.8,
    id: "circle20"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 54.9,
    cy: 194.1,
    r: 0.8,
    id: "circle21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 106.9,
    cy: 217.4,
    r: 0.8,
    id: "circle22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 160.7,
    cy: 201.9,
    r: 0.8,
    id: "circle23"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 205,
    cy: 197.2,
    r: 0.8,
    id: "circle24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 188.7,
    cy: 170.5,
    r: 0.8,
    id: "circle25"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 72.3,
    cy: 124.2,
    r: 0.8,
    id: "circle26"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.7,
    cy: 108.8,
    r: 0.8,
    id: "circle27"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 49.7,
    cy: 55.1,
    r: 0.8,
    id: "circle28"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63,
    cy: 16.6,
    r: 0.8,
    id: "circle29"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25.9,
    cy: 2.7,
    r: 0.8,
    id: "circle30"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.6,
    cy: 35,
    r: 0.8,
    id: "circle31"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.8,
    cy: 218.4,
    r: 0.8,
    id: "circle32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 58.6,
    cy: 216.9,
    r: 0.8,
    id: "circle33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82.6,
    cy: 170.5,
    r: 0.8,
    id: "circle34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 184,
    cy: 208.3,
    r: 0.8,
    id: "circle35"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 215.3,
    cy: 196.9,
    r: 0.8,
    id: "circle36"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 147,
    cy: 183.8,
    r: 0.8,
    id: "circle37"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 123.1,
    cy: 217.3,
    r: 0.8,
    id: "circle38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 104.6,
    cy: 177.9,
    r: 0.8,
    id: "circle39"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 191.5,
    cy: 154.9,
    r: 0.8,
    id: "circle40"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 178.8,
    cy: 125.7,
    r: 0.8,
    id: "circle41"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 182.3,
    cy: 83.9,
    r: 0.8,
    id: "circle42"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 218.1,
    cy: 57.1,
    r: 0.8,
    id: "circle43"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 206.9,
    cy: 19.4,
    r: 0.8,
    id: "circle44"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 174.3,
    cy: 38,
    r: 0.8,
    id: "circle45"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 149.4,
    cy: 13.7,
    r: 0.8,
    id: "circle46"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 112,
    cy: 29.5,
    r: 0.8,
    id: "circle47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 95,
    cy: 9.8,
    r: 0.8,
    id: "circle48"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 130.4,
    cy: 71.3,
    r: 0.8,
    id: "circle49"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.4,
    cy: 33.3,
    r: 0.8,
    id: "circle50"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.1,
    cy: 26.3,
    r: 0.8,
    id: "circle51"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.2,
    cy: 64.9,
    r: 0.8,
    id: "circle52"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 45.2,
    cy: 66.2,
    r: 0.8,
    id: "circle53"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82,
    cy: 78.8,
    r: 0.8,
    id: "circle54"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 104.6,
    cy: 98.5,
    r: 0.8,
    id: "circle55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.8,
    cy: 102.6,
    r: 0.8,
    id: "circle56"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.5,
    cy: 104.9,
    r: 0.8,
    id: "circle57"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.1,
    cy: 142.5,
    r: 0.8,
    id: "circle58"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48.3,
    cy: 167.2,
    r: 0.8,
    id: "circle59"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.6,
    cy: 146.9,
    r: 0.8,
    id: "circle60"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 67.5,
    cy: 201.7,
    r: 0.8,
    id: "circle61"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.8,
    cy: 191.8,
    r: 0.8,
    id: "circle62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 9.4,
    cy: 217.9,
    r: 0.8,
    id: "circle63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 134.2,
    cy: 121.3,
    r: 0.8,
    id: "circle64"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg11);
export default __webpack_public_path__ + "static/media/bg11.54df3ea5053e14a137d38f4cf9c69bfe.svg";
export { ForwardRef as ReactComponent };